module.exports = __webpack_public_path__ + "img/team_3.a44ea0cd.png";